<template>
    <rkm-modal
        large
        ref="RkmModal"
        title="Atestado Médico"
    >
        <Form
            :data="data"
            :model="model"
            @saved="saved"
            ref="Form"
        />

         <template v-slot:footer>
            <template>
                <rkm-button @click="close">
                    Fechar
                </rkm-button>

                <rkm-button @click="print()">
                    Imprimir
                </rkm-button>

                <rkm-button
                    @click="save"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Enums.
import atestadoTipo from '@/enums/pronto-atendimento/atendimento-medico/atestadoTipo'
import atestadoModelo from '@/enums/pronto-atendimento/atendimento-medico/atestadoModelo'

// Mixins.
import { repository, error, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { Form },
    created() {

        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.prontoAtendimento.atendimentoMedico')
        }
    },
    data: () => ({
        model: {},
        enums: {
            atestadoTipo,
            atestadoModelo,
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open() {

            this.model = Object.assign({}, {
                nome: this.data.model.atestado.nome,
                paciente: this.data.model.atestado.paciente,
                imprimeCid: this.data.model.atestado.imprimeCid,
                modeloId: this.data.model.atestado.modeloId || this.enums.atestadoModelo.PADRAO,
                dias: this.data.model.atestado.dias,
                quantidadeHoras: this.data.model.atestado.quantidadeHoras,
                horarioInicial: this.data.model.atestado.horarioInicial,
                documentoTipoId: this.data.model.atestado.documentoTipoId,
                documentoNumero: this.data.model.atestado.documentoNumero,
                atendidoEm: this.data.form.recepcao.atendidoEm,
            })
            this.$refs.RkmModal.show()
        },
        print() {

            if(this.model.paciente == this.enums.atestadoTipo.PACIENTE) {
                this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.repositories.impressao.atestado(null, this.camelObjectKeysToSnakeRecursive({
                        ...this.model,
                        pacienteId: this.data.form.paciente.id,
                        cid_id: this.data.model.cid ? this.data.model.cid.id : null
                    }))
                        .then(response => {

                            const content = new Blob([response.data], { type: response.headers['content-type'] })
                            const url = URL.createObjectURL(content)
                            const link = document.createElement('a')

                            link.href = url
                            link.target = '_blank'
                            link.click()

                            URL.revokeObjectURL(url);
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
            } else {
                this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.repositories.impressao.atestadoAcompanhante(null, this.camelObjectKeysToSnakeRecursive({
                        ...this.model,
                        pacienteId: this.data.form.paciente.id,
                        cid_id: this.data.model.cid ? this.data.model.cid.id : null
                    }))
                        .then(response => {

                            const content = new Blob([response.data], { type: response.headers['content-type'] })
                            const url = URL.createObjectURL(content)
                            const link = document.createElement('a')

                            link.href = url
                            link.target = '_blank'
                            link.click()

                            URL.revokeObjectURL(url);
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
            }
        },
        close() {
            this.$refs.RkmModal.hide()
        },
        save() {
            this.$refs.Form.save()
        },
        saved() {
            this.close()
        },
    },
    mixins: [repository, error, stringCase],
    props: {
        data: { type: Object, required: true },
    },
}
</script>